import React from 'react';
import { trackCheckoutStart } from '../lib/metaPixel';

/** The single checkout every purchase button leads to. */
export const CHECKOUT_URL = 'https://make-up-instructor-ready.impultienda.ar/checkout';
export const CURRENCY_NOTE = 'Payments are processed in your local currency';

/** Anchor of the offer block. */
export const OFFER_ANCHOR = '#offer-cta';
type CtaAction = 'checkout' | 'offer';
interface CtaButtonProps {
  label: string;
  /** 'checkout' opens the checkout; 'offer' scrolls to the offer block. */
  action?: CtaAction;
  className?: string;
}
export function CtaButton({
  label,
  action = 'offer',
  className = ''
}: CtaButtonProps) {
  const isCheckout = action === 'checkout';
  return <a href={isCheckout ? CHECKOUT_URL : OFFER_ANCHOR} onClick={isCheckout ? trackCheckoutStart : undefined} className={`group inline-flex items-center justify-center gap-2.5 text-balance rounded-[16px] bg-brand-cta px-4 py-[22px] text-center font-body text-[14px] font-extrabold uppercase tracking-[0.02em] text-brand-cta-text shadow-[0_6px_0_0_#0A6B34,0_22px_40px_-12px_rgba(19,161,80,0.65)] transition-[background-color,transform,box-shadow] duration-150 ease-out hover:bg-brand-cta-dark active:translate-y-[4px] active:shadow-[0_2px_0_0_#0A6B34] focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-cta focus-visible:ring-offset-2 sm:px-10 sm:py-6 sm:text-[17px] sm:tracking-[0.05em] ${className}`} data-id="element-1" data-mp="vb0jscgcgulf">
      <span data-id="element-2" data-mp="3ovrxqtr60h6e">{label}</span>
      <span aria-hidden="true" className="hidden text-base font-normal transition-transform duration-200 ease-out group-hover:translate-x-1 sm:inline" data-id="element-3" data-mp="3sxlvou9z772v">
        →
      </span>
    </a>;
}
interface CtaBlockProps {
  label: string;
  action?: CtaAction;
  /** Small reassurance line under the button. */
  note?: string;
  /** 'light' for use on dark backgrounds. */
  tone?: 'dark' | 'light';
  className?: string;
}

/** Centered CTA block with the local-currency note above the button. */
export function CtaBlock({
  label,
  action = 'offer',
  note,
  tone = 'dark',
  className = ''
}: CtaBlockProps) {
  const muted = tone === 'light' ? 'text-white/65' : 'text-brand-charcoal/55';
  return <div className={`flex flex-col items-center text-center ${className}`} data-id="element-4" data-mp="hw6sfz3ctq9">
      <p className={`font-body text-[11px] uppercase tracking-[0.14em] ${muted}`} data-id="element-5" data-mp="jz4lm6hjr5j">{CURRENCY_NOTE}</p>
      <CtaButton label={label} action={action} className="mt-4 w-full sm:w-auto sm:min-w-[460px]" data-id="element-6" data-mp="3ruh32u9ra26m" />
      {note && <p className={`mt-4 font-body text-[12px] uppercase tracking-[0.12em] ${muted}`} data-id="element-7" data-mp="9kdnyfzw2w6e">{note}</p>}
    </div>;
}